<template>
    <div id="components-main-layout" v-if="check">
        <a-layout :style="{ zIndex: 1, height: '100%' }">
            <menu_sidebar>这里是sidebar</menu_sidebar>
            <a-layout :style="{ zIndex: 2 }">
                <header_bar>这里是header</header_bar>
                <a-layout-content :style="{padding:'0 20px'}">
                    <div>
                        <a-row :style="{marginTop:'10px',}">
                            <a-breadcrumb>
                                <a-breadcrumb-item>借款/报销单</a-breadcrumb-item>
                                <a-breadcrumb-item>添加/修改</a-breadcrumb-item>
                            </a-breadcrumb>
                        </a-row>
                        <a-row>
                            <div style="background:#FFFFFF;width:100%;margin-top:10px;border-top:4px solid #CCCCCC;padding:10px;">
                                <a-row  :style="{margin:'5px 0 5px 0'}">
                                    <a-col :span="24" align="left"><span style="font-size:18px;">添加/修改 借款/报销单</span></a-col>
                                </a-row>
                                <a-row>
                                    <a-form-model
                                        :form="form"
                                        :model = "json_data"
                                        ref="ruleForm"
                                        :label-col="{ span: 5,offset:1}"
                                        :wrapper-col="{ span: 18 }"
                                        :rules="rules"
                                        :hideRequiredMark = false
                                        :validateOnRuleChange = true
                                    >
                                        <a-col :span="12">
                                            <a-form-model-item label="核算单位" prop="company">
                                                <a-input
                                                    placeholder="核算单位名称(简称)"
                                                    v-model="json_data.company"
                                                />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="单据类型" prop="new_type">
                                                <a-select v-model="json_data.new_type" placeholder="请选择借款单类型">
                                                    <a-select-option value="2">借款单</a-select-option>
                                                    <a-select-option value="1">报销单</a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="单号前缀" prop="pre">
                                                <a-input placeholder="单号前缀，例如 BM" v-model="json_data.pre" />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="单号编号" prop="no">
                                                <a-input placeholder="预想单号，前面不用补 0" v-model="json_data.no" />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="货币类型" prop="currency">
                                                <a-select v-model="json_data.currency" placeholder="请选择货币类型">
                                                    <a-select-option value="CNY">人民币</a-select-option>
                                                    <a-select-option value="USD">美元</a-select-option>
                                                    <a-select-option value="EUR">欧元</a-select-option>
                                                    <a-select-option value="GBP">英镑</a-select-option>
                                                    <a-select-option value="JPY">日元</a-select-option>
                                                    <a-select-option value="HKD">港币</a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="第一审核日期" prop="examine1_time">
                                                <a-date-picker style="width:100%" v-model="json_data.examine1_time"
                                                    format="YYYY-MM-DD"
                                                />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="第二审核日期" prop="examine2_time">
                                                <a-date-picker style="width:100%" v-model="json_data.examine2_time"
                                                               format="YYYY-MM-DD"
                                                />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="第三审核日期" prop="examine3_time">
                                                <a-date-picker style="width:100%" v-model="json_data.examine3_time"
                                                               format="YYYY-MM-DD"
                                                />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="单据创建时间" prop="create_time">
                                                <a-date-picker style="width:100%" v-model="json_data.create_time"
                                                               format="YYYY-MM-DD"
                                                />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="支付方式" prop="pay_type">
                                                <a-select v-model="json_data.pay_type" placeholder="请选择支付方式">
                                                    <a-select-option value="1">现金</a-select-option>
                                                    <a-select-option value="2">支票</a-select-option>
                                                    <a-select-option value="3">网银转账</a-select-option>
                                                    <a-select-option value="4">付汇</a-select-option>
                                                    <a-select-option value="5">电子支付</a-select-option>
                                                </a-select>
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="支付账户" prop="check_no">
                                                <a-input placeholder="支票号，银行账户等，可不填" v-model="json_data.check_no" />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12">
                                            <a-form-model-item label="备注信息">
                                                <a-input
                                                    placeholder="备注信息"
                                                    v-model="json_data.remark"
                                                />
                                            </a-form-model-item>
                                        </a-col>
                                        <a-col :span="12" align="right">
                                            <a-button type="primary" @click="onSubmit">保存</a-button>
                                        </a-col>
                                    </a-form-model>
                                </a-row>
                            </div>
                        </a-row>
                    </div>
                </a-layout-content>
            </a-layout>
        </a-layout>
    </div>
</template>

<script>
import menu_sidebar from '../components/menu_sidebar'
import header_bar from '../components/header'
import Cookies from "js-cookie";
import axios from "axios";
import moment from "moment";

export default {
    name: "bogus_op",
    components:{
        menu_sidebar,
        header_bar,
    },
    data(){
        return{
            check:true,
            current: ['23'],
            openKeys: ['2'],
            form:{
              title:'12313',
            },
            rules:{
                company: [
                    { required: true, message: '请输入核算单位', trigger: 'blur' },
                    { min: 6, max: 32, message: '长度 6-32 位', trigger: 'blur' },
                ],
                new_type: [
                    { required: true, message: '请选择单据类型', trigger: 'blur' },
                ],
                pre: [
                    { required: true, message: '请输入单号前缀', trigger: 'blur' },
                    { min: 2, max: 2, message: '长度 2 位', trigger: 'blur' },
                ],
                no: [
                    { required: true, message: '请填写单号编号', trigger: 'blur' },
                ],
                create_time: [
                    { required: true, message: '请填写创建时间', trigger: 'blur' },
                ],
                examine1_time: [
                    { required: true, message: '请填写第一审核时间', trigger: 'blur' },
                ],
                examine2_time: [
                    { required: true, message: '请填写第二审核时间', trigger: 'blur' },
                ],
                examine3_time: [
                    { required: true, message: '请填写第三审核时间', trigger: 'blur' },
                ],
                pay_type: [
                    { required: true, message: '请选择支付方式', trigger: 'blur' },
                ],
            },
            formLayout: 'horizontal',
            json_data:{
                action:'bogus',
                type:'OP',
                ID:'',
                token:'0',
                company:'',
                new_type:'',
                pre:'',
                no:'',
                pay_type:'',
                remark:'',
                check_no:'',
                examine1_time:'',
                examine2_time:'',
                examine3_time:'',
                create_time:'',
            },
            json_data_get:{
                action:'bogus',
                type:'OP_DETAIL',
                token:'',
                id:''
            },
        }
    },
    beforeMount() {
        var token = Cookies.get('Token');
        var json_data = '{"action":"CheckToken","token":"'+token+'"}';
        let self = this;
        axios.post('/api/index.php',json_data)
            .then((response)=> {
                if(response.data.status!=1){
                    self.$router.push({path:'/login'})
                }else{
                    this.check = true;
                    this.json_data.token = token;
                    this.json_data_get.token = token;
                    this.json_data.ID = this.$route.params.id;
                    this.json_data_get.id = this.$route.params.id;
                    if(this.$route.params.id != undefined){
                        axios.post('/api/index.php',this.json_data_get)
                            .then((response)=> {
                                if(response.data.status == 1){
                                    this.json_data.company = response.data.data.company;
                                    this.json_data.pre = response.data.data.pre;
                                    this.json_data.no = response.data.data.no;
                                    this.json_data.currency = response.data.data.currency;
                                    this.json_data.pay_type = response.data.data.pay_type;
                                    this.json_data.remark = response.data.data.remark;
                                    this.json_data.check_no = response.data.data.check_no;
                                    this.json_data.new_type = response.data.data.new_type;
                                    this.json_data.examine1_time = moment(response.data.data.examine1_time, 'YYYY-MM-DD');
                                    this.json_data.examine2_time = moment(response.data.data.examine2_time, 'YYYY-MM-DD');
                                    this.json_data.examine3_time = moment(response.data.data.examine3_time, 'YYYY-MM-DD');
                                    this.json_data.create_time = moment(response.data.data.create_time, 'YYYY-MM-DD');
                                }else{
                                    self.$message.error(response.data.message);
                                }
                            })
                            .catch(function (error) { // 请求失败处理
                                self.$message.error(error);
                            });
                    }
                }
            })
            .catch(function (error) { // 请求失败处理
                console.log(error);
            });
        this.$store.commit("sidebar_current", ['23'])
        this.$store.commit("sidebar_openKeys", ['2'])
    },
    methods:{
        onSubmit() {
            let self = this;
            this.$refs.ruleForm.validate(valid => {
                if(valid){
                    this.json_data.examine1_time = moment(this.json_data.examine1_time).format('YYYY-MM-DD');
                    this.json_data.examine2_time = moment(this.json_data.examine2_time).format('YYYY-MM-DD');
                    this.json_data.examine3_time = moment(this.json_data.examine3_time).format('YYYY-MM-DD');
                    this.json_data.create_time = moment(this.json_data.create_time).format('YYYY-MM-DD');
                    axios.post('/api/index.php',this.json_data)
                    .then((response)=>{
                        if(response.data.status ==1){
                            self.$router.push({path:'/bogus'})
                        }else{
                            self.$message.error(response.data.message);
                        }
                    })
                    .catch(function(error){
                        self.$message.error(error);
                    })
                }else{
                    //console.log(valid)
                    return false;
                }
            })
        },
    },
}
</script>

<style scoped>
#components-main-layout{height:100%;width:100%;}
#components-main-layout {
    /*text-align: center;*/
}

#components-main-layout .ant-layout-sider {
    background: #E9EEF3;
    color: #fff;
}
#components-main-layout .ant-layout-content {
    background: #E9EEF3;
}
#components-main-layout > .ant-layout {
    margin-bottom: 48px;
}
#components-main-layout > .ant-layout:last-child {
    margin: 0;
}
/*.ant-form-item{margin-bottom:15px;}*/
/*.ant-form-item input{height:40px;}*/
</style>